import React, {Component} from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import MobileMenu from '../components/MobileMenu';
import axios from "axios";
import {Link} from 'react-router-dom';

class Projects extends Component{

    constructor(props) {
        super(props);
        this.state = {
            global_content: [],
            our_services: [],
            group_of_companies: [],
            our_products: [],
            
           
        }
    }
    componentWillMount() {
        console.log('First this called');
    }

    getData() {

        axios.get(`https://cityfort.ae/php/global.php`)
            .then(response => {
                this.setState({ global_content: response.data.global_content })
                this.setState({ our_services: response.data.our_services })
                this.setState({ group_of_companies: response.data.group_of_companies })
                this.setState({ our_products: response.data.our_products })
            })
            .catch(e => {
                console.log(e);
                this.setState({ ...this.state, isFetching: false });
            });
    }


    componentDidMount() {
        this.getData();
    }



    render(){

        // let data = [
        //     {pageLink: 'project-details', img: 'project-1.jpg', projectTitle: 'Land Minning', projectSubtitle: 'Lorem ipsum dolor sit amet consect adipisi elit sed do eiusm tempor'},
        //     {pageLink: 'project-details', img: 'project-2.jpg', projectTitle: 'Work Management', projectSubtitle: 'Lorem ipsum dolor sit amet consect adipisi elit sed do eiusm tempor'},
        //     {pageLink: 'project-details', img: 'project-3.jpg', projectTitle: 'Material Engineering', projectSubtitle: 'Lorem ipsum dolor sit amet consect adipisi elit sed do eiusm tempor'},
        //     {pageLink: 'project-details', img: 'project-4.jpg', projectTitle: 'Power and Energy', projectSubtitle: 'Lorem ipsum dolor sit amet consect adipisi elit sed do eiusm tempor'},
        //     {pageLink: 'project-details', img: 'project-5.jpg', projectTitle: 'Land Minning', projectSubtitle: 'Lorem ipsum dolor sit amet consect adipisi elit sed do eiusm tempor'},
        //     {pageLink: 'project-details', img: 'project-6.jpg', projectTitle: 'Work Management', projectSubtitle: 'Lorem ipsum dolor sit amet consect adipisi elit sed do eiusm tempor'},
        //     {pageLink: 'project-details', img: 'project-7.jpg', projectTitle: 'Material Engineering', projectSubtitle: 'Lorem ipsum dolor sit amet consect adipisi elit sed do eiusm tempor'},
        //     {pageLink: 'project-details', img: 'project-8.jpg', projectTitle: 'Power and Energy', projectSubtitle: 'Lorem ipsum dolor sit amet consect adipisi elit sed do eiusm tempor'}
        // ];

        let Datalist = this.state.our_products.map((val, i)=> {
            return(
                <div className="col-lg-4 col-sm-6 col-12 section-space--bottom--30" key={i}>
                    <div className="service-grid-item service-grid-item--style2">
                    <div className="service-grid-item__image">
                        <div className="service-grid-item__image-wrapper">
                        <Link   to={`project-details/${val.id}`} >
                            <img src={`https://cityfort.ae/images/${val.main_image}`} className="img-fluid" alt="" />
                        </Link>
                        </div>
                    </div>
                    <div className="service-grid-item__content">
                        <h3 className="title">
                        <Link   to={`project-details/${val.id}`} >{val.title}</Link>
                        </h3>
                        <p className="subtitle">{val.description}</p>
                        <Link   to={`project-details/${val.id}`}  className="see-more-link">SEE MORE</Link>
                    </div>
                    </div>
                </div>
            )
        });

        return(
            <div>
                {/* Navigation bar */}
                <NavBar data={this.state.global_content}/>

                {/* breadcrumb */}
                {/*====================  breadcrumb area ====================*/}
                <div className="breadcrumb-area breadcrumb-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <div className="page-banner text-center">
                                    <h1>Our Projects</h1>
                                    <ul className="page-breadcrumb">
                                        <li><Link to="/">Home</Link></li>
                                        <li>Our Projects</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*====================  End of breadcrumb area  ====================*/}

                {/*====================  project page content ====================*/}
                <div className="page-wrapper section-space--inner--120">
                    {/*Projects section start*/}
                    <div className="project-section">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="project-item-wrapper">
                                        <div className="row">
                                            {Datalist}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row section-space--top--60">
                                <div className="col">
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*Projects section end*/}
                </div>

                {/*====================  End of project page content  ====================*/}

                
                {/* Brand logo */}

                {/* Footer */}
                <Footer data={this.state.global_content} />

                {/* Mobile Menu */}
                <MobileMenu/>
            </div>
        )
    }
}


export default Projects;